const restclient = require('../restclient')({
  baseURL: '/navigation/api',
  timeout: 10000,
});

const SERVICE_BASE_PATH = '/addresses-hub';

function updateCurrentLoaction(data) {
  const params = Object.fromEntries(new URLSearchParams(window.location.search));
  return restclient.post(SERVICE_BASE_PATH, { params, data }).then((rs) => rs.data);
}

module.exports = { updateCurrentLoaction };
